import Api from '@/services/Api';
import Privilegio from '@/model/Privilegio';

const RECURSO = '/privilegios';
export default {
    newPrivilegio,
    getAllPrivilegio,
    getPrivilegio,
    postPrivilegio,
    postPrivilegioRetornar,
    putPrivilegio,
    deletePrivilegio
};

function newPrivilegio(id=0,nome='',descricao=''){
    return new Privilegio(id, nome, descricao);
}


function getAllPrivilegio () {
    return Api.get(`${RECURSO}`);
}

function getPrivilegio (id) {
    return Api.get(`${RECURSO}/${id}`);
}

function postPrivilegio(payload){
    return Api.post(`${RECURSO}`, payload);
}

function postPrivilegioRetornar(payload){
    return Api.post(`${RECURSO}/retornar`, payload);
}

function putPrivilegio(payload){
    return Api.put(`${RECURSO}/${payload.id}`, payload);
}

function deletePrivilegio(id){
    return Api.delete(`${RECURSO}/${id}`);
}